import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

const Breadcrumbs = ({ items }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 space-x-reverse text-sm py-4 px-4 bg-white rounded-lg shadow-sm">
      {/* Home */}
      <Link
        to="/"
        className="flex items-center text-gray-500 hover:text-indigo-600 transition-colors"
      >
        <HomeIcon className="h-4 w-4 ml-1" />
        <span>בית</span>
      </Link>

      {/* Breadcrumb Items */}
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <ChevronRightIcon className="h-4 w-4 text-gray-400" />
          {index === items.length - 1 ? (
            // Current page - not clickable
            <span className="text-gray-900 font-medium">{item.name}</span>
          ) : (
            // Clickable link
            <Link
              to={item.url}
              className="text-gray-500 hover:text-indigo-600 transition-colors"
            >
              {item.name}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
